<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div>
        <div v-if="faIcon">
            <div
                class="cursor-pointer rounded-full w-10 h-10 relative"
                :class="`${color ? color : 'text-white'} ${backgroundColor ? backgroundColor : 'bg-secondary'}`"
            >
                <i class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" :class="faIcon"></i>
            </div>
        </div>
        <div v-else>
            <div
                class="cursor-pointer rounded-md px-4 py-2 border border-secondary hover:bg-secondary hover:text-white uppercase"
                :class="`${color ? color : 'text-secondary'}`"
            >
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ButtonComponent',
    props: {
        faIcon: {
            required: false
        },
        color: {
            required: false
        },
        backgroundColor: {
            required: false
        }
    }
};
</script>

<style scoped></style>
